import { render, staticRenderFns } from "./StudentEvaluations.vue?vue&type=template&id=32332216"
import script from "./StudentEvaluations.vue?vue&type=script&lang=js"
export * from "./StudentEvaluations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports